export const DEALER_CONTEXT_UNSUBSCRIBE = 'unsubscribe';
export const DEALER_CONTEXT_AUTOCONNECT_UNSUBSCRIBE = 'auto-connected-unsubscribe';
export const KEY_DEALER_DATA = 'fa-header-dealer-data';
